// components/GlobalStyles.jsx
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import { alpha } from '@mui/material/styles';

const GlobalStyles = () => {
  return (
    <MuiGlobalStyles
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        html: {
          scrollBehavior: 'smooth',
        },
        body: {
          overflowX: 'hidden',
        },
        '.gradient-text': {
          background: 'linear-gradient(135deg, #FFD700 0%, #FFE55C 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        },
        '.glass-effect': {
          background: 'rgba(13, 13, 13, 0.7)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 215, 0, 0.2)',
        },
        '.animate-fade-in-up': {
          animation: 'fadeInUp 0.6s ease-out',
        },
        '.animate-slide-in-left': {
          animation: 'slideInLeft 0.6s ease-out',
        },
        '.animate-slide-in-right': {
          animation: 'slideInRight 0.6s ease-out',
        },
        '.animate-pulse': {
          animation: 'pulse 2s infinite',
        },
        '.animate-float': {
          animation: 'float 3s ease-in-out infinite',
        },
        '.shimmer': {
          background: 'linear-gradient(90deg, transparent, rgba(255,215,0,0.1), transparent)',
          backgroundSize: '200% 100%',
          animation: 'shimmer 2s infinite',
        },
        '.hover-lift': {
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 32px rgba(255, 215, 0, 0.15)',
          },
        },
        '.hover-glow': {
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0 0 20px rgba(255, 215, 0, 0.3)',
            borderColor: '#FFD700',
          },
        },
      }}
    />
  );
};

export default GlobalStyles;